<template>
  <div class="detail_list">
    <div class="search_condition">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="收益类型：">
          <el-select
            v-model="formInline.spend_type"
            :popper-append-to-body="false"
            class="consumer-select"
            placeholder="请选择"
            size="medium"
            clearable
            style="width: 156px"
          >
            <el-option v-for="item in spend_type_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!--
        <el-form-item label="订单号：">
          <el-input v-model="formInline.order_no"
                    class="inconme-input"
                    size="medium"
                    style="242px"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
        -->
        <el-form-item label="交易时间：">
          <el-date-picker
            v-model="formInline.time"
            class="dataTimer"
            type="daterange"
            size="medium"
            range-separator="-"
            prefix-icon="el-icon-date"
            popper-class="dateTimer-droper"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getListInfo" class="select-btn" plain>查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      :data="tableData"
      :row-style="{ height: '56px', fontSize: '14px' }"
      :cell-style="{ padding: 0 }"
      :header-row-style="tableHeaderRow"
      :header-cell-style="tableHeaderColor"
      height="100%"
      style="width: 100%"
    >
      <el-table-column prop="order_no" label="订单号" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="cursor: pointer" class="share-copy" :data-clipboard-text="scope.row.order_no" @click="copy()">{{ scope.row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="profit_type_name" label="收益类型" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="create_time" label="交易时间" width="179" align="center">
        <template slot-scope="scope">
          <div class="create_time_top">{{ moment(scope.row.create_time).format("YYYY-MM-DD ") }}</div>
          <div class="create_time_top">{{ moment(scope.row.create_time).format("HH:mm:ss") }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sender_name" label="赠送者" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="res_name" label="赠送内容" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="count" label="赠送数量" width="80" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.count > 0">{{ scope.row.count == scope.row.coin_count ? scope.row.count / 100 : scope.row.count }}</span>
          <span v-else style="color: #333">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin_count" label="收入鹰钻" width="99" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="color: #02a8a2" v-if="scope.row.coin_type == 1">{{ scope.row.coin_count / 100 }}</span>
          <span v-else style="color: #333">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin_count" label="收入克拉" width="99" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="color: #02a8a2" v-if="scope.row.coin_type == 2">{{ scope.row.coin_count / 100 }}</span>
          <span v-else style="color: #333">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="profit_type_name" label="结算对象" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.coin_type == 1 ? "鹰钻" : "克拉" }}</span>
        </template>
      </el-table-column>
      <div slot="empty" class="search_list">
        <div class="list_body">
          <div class="empty_content">
            <!--
            <div class="empty_text">暂无任何记录哦～</div>
            -->
            <Empty text="暂时没有收入数据" :imgWidth="250" :img="require('@/assets/img/empty/income.png')"></Empty>
          </div>
        </div>
      </div>
    </el-table>

    <div class="pagination_bottom">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="info.size"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="info.page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import moment from "moment";
import Empty from "@/components/empty/empty";
import Cipboard from "clipboard";
export default {
  components: {
    Empty,
  },
  data() {
    return {
      moment: moment,
      spend_type_list: [
        { label: "活动", value: 3 },
        { label: "鹰选彩金", value: 2 },
        { label: "礼物", value: 1 },
        { label: "全部", value: 0 },
      ],
      formInline: {
        spend_type: "",
        order_no: "",
        time: [],
      },
      tableData: [],
      info: {
        page: 1,
        size: 8,
      },
      totalCount: 0,
    };
  },
  props: {},
  created() {
    console.log(this.info);
    // this.getlistinfo();
  },
  mounted() {
    this.$nextTick(() => {
      let keyNode = document.querySelector(".el-date-editor");
      let inserNode = document.querySelector(".el-icon-date");
      //console.log(keyNode);
      this.getListInfo();
    });
  },
  methods: {
    copy() {
      var copyBtn = new Cipboard(".share-copy");
      copyBtn.on("success", (e) => {
        this.$message.success("复制成功");
        copyBtn.destroy();
      });
    },
    handleSizeChange(val) {
      this.$set(this.info, "size", val);
      // console.log(`每页 ${val} 条`);
      this.selectList();
    },
    handleCurrentChange(val) {
      this.$set(this.info, "page", val);
      //console.log(`当前页: ${val}`);
      this.getListInfo();
    },
    getListInfo() {
      let data = {
        spend_type: this.formInline.spend_type || 0,
        //etimestamp: this.formInline.time,//integer 交易時間 結束日期(s)
        page: this.info.page, //integer //example: 1 頁
        size: this.info.size, //integer example: 20 筆
        //stimestamp: this.formInline.time,	//integer  交易時間 開始日期(s)
      };

      if (this.formInline.time && this.formInline.time.length) {
        data.etimestamp = new Date(this.formInline.time[1]).getTime() / 1000 || "";
        data.stimestamp = new Date(this.formInline.time[0]).getTime() / 1000 || "";
      }

      post({
        url: "/api/order/getIncomeList",
        data,
      }).then(({ data: { data } }) => {
        // const list = data.list.map((item) => {
        //   let live = item.anchor && item.anchor.live;
        //   if (live) return live;
        //   return {
        //     thumb: item.anchor.avatar,
        //     living: !!live,
        //     title: item.anchor.nick_name + this.$t("uc-focus.live-room"),
        //     anchor: item.anchor,
        //     hot: 0,
        //     anchorid: item.anchor.id,
        //   };
        // });
        this.tableData = data.list;
        this.totalCount = data.count;
        this.$emit("backCount", data.count);
      });
    },
    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // return 'background-color: #c7e7e2;color:#526e6e;font-size: 14px;font-weight:600; height: 36px;padding: 0px'
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:500;
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },
    tableHeaderRow() {
      //return 'height: 36px'
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },
  },
};
</script>
<style lang="stylus" scoped>

.create_time_top {
  line-height: 1;
}
/deep/.el-form-item__label{
      color: #333;
}


.demo-form-inline {
  ppadding : 0px 5px;
  justify-content: space-between !important;

  .consumer-select {
    // margin-right: 59px;
  }

  .dataTimer {
    width: 264px;
  }
}
.search_list {
  width: 100%;

  .list_body {
    height: 444px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .empty_content {
      img {
        width: 136px;
        height: 156px;
        margin-bottom: 39px;
      }

      .empty_text {
        font-size: 14px;
        color: #999;
        text-align: center;
      }
    }
  }
}
</style>
